/* eslint-disable react/no-direct-mutation-state */
import React from 'react';
import { connect } from "react-redux";
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { injectIntl } from "react-intl";
import Form, { Item as FormItem, SimpleItem, RequiredRule, GroupItem, RangeRule } from 'devextreme-react/form';
import { withSnackbar } from 'notistack';
import * as companiesCrud from '../../../../crud/companies.crud';
import * as templatesCrud from '../../../../crud/templates.crud';
import * as migrationCrud from '../../../../crud/migration.crud';
import * as customFieldCrud from '../../../../crud/customField.crud';
import FileUploader from 'devextreme-react/file-uploader';
import { adjustContractTemplate } from "../../../../Templates/TemplateAdjust";
import Common from '../../../../shared/common';
import MigrationHelper, { MIGRATION_MODE } from "../../../../shared/migrationHelper";
import { paymentPeriods, calculationPeriods } from '../../../../shared/lookup';
import saveAs from 'file-saver';
import { LoadPanel } from 'devextreme-react/load-panel';
//IMPORT FORM FIELDS FROM REGISTER PAGE
import { getBatchFormFields as TaskOrderConfig } from '../../../contract/tasks/Task/List';
import { getBatchFormFields as RFQConfig } from '../../../contract/tasks/Rfq/List';
import { getBatchFormFields as ProjectOrderConfig } from '../../../contract/projects/Project/List';
import { getBatchFormFields as ITQConfig } from '../../../contract/projects/Itq/List';
import { getBatchFormFields as EWConfig } from '../../../contract/early-warning/Warning/List';
import { getBatchFormFields as SharedConfig } from '../../../contract/_SharedWorkflow/Notify/List';
import { getBatchFormFields as CertificateConfig } from '../../../contract/certificates/Certificate/List';
import { getBatchFormFields as ProgramConfig } from '../../../contract/programme/Program/List';
import { getBatchFormFields as ProposalConfig } from '../../../contract/proposals/proposal/List';
import { getBatchFormFields as SubmissionConfig } from '../../../contract/submissions/Submission/List';
import { getBatchFormFields as RfitqConfig } from '../../../contract/rfi-tq/Rfi/List';
import { getBatchFormFields as DefectConfig } from '../../../contract/defects/Defect/List';
import { getBatchFormFields as CEConfig } from '../../../contract/compensation-events/compensation/List';
import { getBatchFormFields as CEInstructionConfig } from '../../../contract/compensation-events/instruction/List';
import { getBatchFormFields as CEClaimConfig } from '../../../contract/compensation-events/claims/List';
import { getBatchFormFields as CENAssessmentConfig } from '../../../contract/compensation-events/assessment/List';
import { getBatchFormFields as QuotationConfig } from '../../../contract/compensation-events/quotes/List';
import { getBatchFormFields as TestsAndInspectionsConfig } from '../../../contract/defects/Inspection/List';
import { getBatchFormFields as ExtensionConfig } from '../../../contract/compensation-events/extension/List';
import { getBatchFormFields as AssumptionConfig } from '../../../contract/compensation-events/assumption/List';
import { getBatchFormFields as DelegatedActionsConfig } from '../../../contract/delegated-actions/Action/List';
import { getBatchFormFields as MeetingsConfig } from '../../../contract/records/Record/List';
import { getBatchFormFields as NonConformanceConfig } from '../../../contract/non-conformance/conformance/List';
import { getBatchFormFields as SiteDiaryWeatherConfig } from '../../../contract/records/Diary/List';
import { getBatchFormFields as PaymentCertificateConfig } from '../../../contract/payments/Payment/List';
import { getBatchFormFields as InstructionToSearchConfig } from '../../../contract/defects/Instruction/List';
import { getBatchFormFields as RfqQuotationConfig } from '../../../contract/tasks/Quotes/List';
import { getBatchFormFields as ItqQuotationConfig } from '../../../contract/projects/Quotes/List';
import { getBatchFormFields as ForecastConfig } from '../../../contract/forecast/Forecast/List';
import { getBatchFormFields as AssessmentConfig } from '../../../contract/assessments/assessment/List';

const fileExtensions = ['.xlsx'];

export const RESPONSES = {
    SAVE: 'SAVE',
    CANCEL: 'CANCEL',
};

class MigrationCreateModal extends React.Component {
    constructor(props) {
        super(props);
        this.validatorRef = React.createRef();
        this.validatorName = 'ContractActionCreateModalValidator';
        this.formRef = React.createRef();
        this.popupRef = React.createRef();
        this.fileUploaderRef = React.createRef();
        this.loadPanelRef = React.createRef();
        this.formData = {}
        this.defaultFields = null;
        this.state = {
            selectedTemplate: null,
            processedData: null,
            processedFileName: null
        }
    }
    componentDidMount() {
        // this.popupRef.current.instance().option("toolbarItems[1].disabled", true);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.visible !== true && this.props.visible === true) {
            //popup displayed
            this.state.selectedTemplate = null;
            this.state.processedData = null;
            this.state.processedFileName = null;
            if (this.formRef.current) {
                this.formRef.current.instance().clear();
            }
            if (this.popupRef.current) {
                this.popupRef.current.instance().option("toolbarItems[1].disabled", true);
            }

        }
        else if (prevProps.visible === true && this.props.visible === false) {
            //popup closed
        }

    }
    componentWillUnmount() {
        if (this.props.closeSnackbar) {
            this.props.closeSnackbar();
        }
    }
    onClose = (e) => {
        if (this.props.visible) {
            e.cancel = true;
            if (this.props.closeSnackbar) {
                this.props.closeSnackbar();
            }
            this.props.onDialogResult();
        }
    }

    formFieldDataChanged = async (e) => {
        this.formData = e.component.option("formData");
        if (!this.formData.companyid || !this.formData.mastertemplateid || !this.formData.workflowid || !this.formData.description) {
            //IF ANY FIELD CLEARED MAKE SURE UPLOAD BUTTON IS DISABLED
            this.popupRef.current.instance().option("toolbarItems[1].disabled", true);
        }

        if (this.props.closeSnackbar) {
            this.props.closeSnackbar();
        }
        if (e.dataField === 'companyid') {
            this.fileUploaderRef.current.instance().clear();
            this.state.processedData = null;
            this.state.processedFileName = null
            this.state.selectedTemplate = null;
            let templateDataSource = null;
            if (e.value) {
                templateDataSource = this.getTemplateOptions(Number(e.value));
            }
            e.component.itemOption("mastertemplateid", "editorOptions", { dataSource: templateDataSource });
            e.component.updateData("mastertemplateid", null);
            e.component.itemOption("workflowid", "editorOptions", { dataSource: null });
            e.component.updateData("workflowid", null);
        }
        else if (e.dataField === 'mastertemplateid') {
            this.fileUploaderRef.current.instance().clear();
            this.state.processedData = null;
            this.state.processedFileName = null;
            let workflowDataSource = null;
            if (e.value) {
                const { data: selectedTemplateObj } = await templatesCrud.getTemplate(Number(e.value));
                if (!selectedTemplateObj) { throw new Error("Selected templated not found!") }
                const dummyContract = {
                    contractid: 1,
                    deleted: 0,
                    recordstatus: 1,
                    partystructure: 3,//ALL
                    contracttype: "DUMMY",
                    employercompanyid: 1,
                    supervisorcompanyid: 1,
                    contractorcompanyid: 1,
                    pmcompanyid: 1,
                }
                this.state.selectedTemplate = adjustContractTemplate(dummyContract, selectedTemplateObj, null, this.props.userProfile, true);
                workflowDataSource = this.state.selectedTemplate.workflowGroups.reduce((wfArray, wfg) => {
                    let notifyPossibleWFs = wfg.workflows.filter(wf => (!!wf.config.notifyPossible && (!this.props.wfid || this.props.wfid === wf.id) && MigrationHelper.supportedWorkflows.includes(wf.id)));
                    if (notifyPossibleWFs.length > 0) {
                        wfArray.push(
                            ...notifyPossibleWFs.map(wf => ({
                                value: wf.id,
                                display: `[${Common.Lpad(wf.id, 2)}] ${wf.title}`,
                            }))
                        );
                    }
                    return wfArray;
                }, []);
                ///MASTER QUOTATION WORKFLOW
                workflowDataSource.push({ value: 103, display: "QUOTATION" });
                workflowDataSource.push({ value: 114, display: "RFQQUOTATION" });
                workflowDataSource.push({ value: 118, display: "ITQQUOTATION" });
            }

            e.component.itemOption("workflowid", "editorOptions", { dataSource: workflowDataSource });
            e.component.updateData("workflowid", null);
        }
        else if (e.dataField === 'workflowid') {
            this.fileUploaderRef.current.instance().clear();
            this.state.processedData = null;
            this.state.processedFileName = null;
        }
    }

    getCompaniesListDataSource = () => {
        const datasource = {
            loadMode: 'raw',
            cacheRawData: true,
            load: () => {
                var promise = new Promise((resolve) => {
                    companiesCrud.getCutDownCompaniesList()
                        .then(resp => {
                            resolve(resp.data);
                        })
                });
                return promise;
            }
        }
        return datasource;
    }
    getTemplateOptions = (companyid) => {
        const datasource = {
            loadMode: 'raw',
            cacheRawData: true,
            load: () => {
                var promise = new Promise((resolve, reject) => {
                    templatesCrud.getTemplatesToSelectList(companyid)
                        .then(response => {
                            let retVal = [];
                            if (response.data) {
                                retVal = response.data;
                            }
                            resolve(retVal);
                        })
                        .catch((err) => {
                            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                            reject(err);
                        })
                });
                return promise;
            }
        }
        return datasource;
    }
    getCustomFields = async (companyid, workflowid) => {
        let customFields = null;
        if (workflowid > 100) {
            //IF WORKFLOW GROUP
            //WORKFLOWID = 0 FOR SUB-TYPES AS LIKE QUOTATION
            workflowid = 0;
        }
        const { data: customFieldDef } = await customFieldCrud.getCustomFieldByCompany(companyid, "Workflows");
        if (customFieldDef && customFieldDef.length > 0 && customFieldDef[0] && customFieldDef[0].fields && customFieldDef[0].fields.length > 0) {
            customFields = customFieldDef[0].fields.filter(f => f.workflowid === workflowid);
            customFields = Common.GroupBy(customFields, 'subtype');
        }
        return customFields;
    }
    getWorkflowItem = (workflowid) => {
        if (this.state.selectedTemplate) {
            let workflowItem = this.state.selectedTemplate.workflowsQA[workflowid];
            if (workflowid > 100) {
                //IF WORKFLOW GROUP, FOR SUB-TYPES AS LIKE QUOTATION
                workflowItem = {
                    ...workflowItem,
                    title: "QUOTATION",
                    assetFieldsEnabled: false,
                    replyEnabled: true,
                }
            }
            return workflowItem;
        }
    }
    getFormFields = async (workflowItem, customFields) => {
        let baseFormFields = null;
        //EARLY WARNINGS
        if ([1, 2, 74].includes(workflowItem.id)) {
            baseFormFields = EWConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl);
        }
        // NOTIFICATIONS & INSTRUCTIONS
        else if ([4, 56, 61, 81, 66, 65, 64, 63, 60, 59, 58, 57, 17, 16, 15].includes(workflowItem.id)) {
            baseFormFields = SharedConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl);
        }
        else if (workflowItem.id === 38) {
            const paymentPeriodsTranslated = paymentPeriods.map(p => (this.props.intl.formatMessage({ id: "GENERAL.FORMS." + p })));
            baseFormFields = TaskOrderConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl, paymentPeriodsTranslated);
        }
        else if (workflowItem.id === 62) {
            const paymentPeriodsTranslated = paymentPeriods.map(p => (this.props.intl.formatMessage({ id: "GENERAL.FORMS." + p })));
            baseFormFields = RFQConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl, paymentPeriodsTranslated);
        }
        else if (workflowItem.id === 72) {
            const paymentPeriodsTranslated = paymentPeriods.map(p => (this.props.intl.formatMessage({ id: "GENERAL.FORMS." + p })));
            const calculationPeriodsTranslated = calculationPeriods.map(p => (this.props.intl.formatMessage({ id: "GENERAL.FORMS." + p })));
            baseFormFields = ProjectOrderConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl, paymentPeriodsTranslated, calculationPeriodsTranslated);
        }
        else if (workflowItem.id === 73) {
            const paymentPeriodsTranslated = paymentPeriods.map(p => (this.props.intl.formatMessage({ id: "GENERAL.FORMS." + p })));
            baseFormFields = ITQConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl, paymentPeriodsTranslated);
        }
        else if ([68, 69, 70, 71].includes(workflowItem.id)) {
            baseFormFields = CertificateConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl);
        }
        else if ([14].includes(workflowItem.id)) {
            baseFormFields = ProgramConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl);
        }
        else if ([19].includes(workflowItem.id)) {
            baseFormFields = ProposalConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl);
        }
        else if ([18, 49].includes(workflowItem.id)) {
            baseFormFields = SubmissionConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl);
        }
        else if ([34, 80].includes(workflowItem.id)) {
            baseFormFields = RfitqConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl);
        }
        else if ([23, 24].includes(workflowItem.id)) {
            baseFormFields = DefectConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl);
        }
        //COMPENSATION EVENTS
        else if ([5, 7, 37, 40, 67, 75, 76].includes(workflowItem.id)) {
            baseFormFields = CEConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl);
        }
        //COMPENSATION EVENTS INSTRUCTION
        else if ([6].includes(workflowItem.id)) {
            baseFormFields = CEInstructionConfig(workflowItem.fields, workflowItem.replyFields, null);
        }
        //COMPENSATION EVENTS CONTRACTOR CLAIM
        else if ([46].includes(workflowItem.id)) {
            baseFormFields = CEClaimConfig(workflowItem.fields, workflowItem.replyFields);
        }
        else if ([8, 50, 51].includes(workflowItem.id)) {
            baseFormFields = CENAssessmentConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl);
        }
        else if ([103].includes(workflowItem.id)) {
            baseFormFields = QuotationConfig(workflowItem.quoteFields, workflowItem.quoteReplyFields, this.props.intl);
        }
        else if ([25, 47, 48].includes(workflowItem.id)) {
            baseFormFields = TestsAndInspectionsConfig(workflowItem.fields, workflowItem.replyFields);
        }
        else if ([9, 10].includes(workflowItem.id)) {
            baseFormFields = ExtensionConfig(workflowItem.fields, workflowItem.replyFields, this.props.intl);
        }
        //COMPENSATION EVENTS ASSUMPTION
        else if ([42].includes(workflowItem.id)) {
            baseFormFields = AssumptionConfig(workflowItem.fields, workflowItem.replyFields);
        }
        else if ([27, 28, 29].includes(workflowItem.id)) {
            baseFormFields = DelegatedActionsConfig(workflowItem.fields, null);
        }
        else if ([30, 31].includes(workflowItem.id)) {
            baseFormFields = MeetingsConfig(workflowItem.fields);
        }
        else if ([32, 33].includes(workflowItem.id)) {
            baseFormFields = SiteDiaryWeatherConfig(workflowItem.fields, workflowItem.replyFields);
        }
        else if (workflowItem.id === 43) {
            baseFormFields = NonConformanceConfig(workflowItem.fields);
        }
        else if ([20, 21].includes(workflowItem.id)) {
            baseFormFields = PaymentCertificateConfig(workflowItem.fields);
        }
        else if (workflowItem.id === 22) {
            baseFormFields = InstructionToSearchConfig(workflowItem.fields, workflowItem.replyFields);
        }
        else if ([114].includes(workflowItem.id)) {
            baseFormFields = RfqQuotationConfig(workflowItem.quoteFields, workflowItem.quoteReplyFields, this.props.intl);
        }
        else if ([118].includes(workflowItem.id)) {
            baseFormFields = ItqQuotationConfig(workflowItem.quoteFields, workflowItem.quoteReplyFields, this.props.intl);
        }
        else if ([52, 53].includes(workflowItem.id)) {
            baseFormFields = ForecastConfig(workflowItem.fields, workflowItem.id);
        }
        else if (workflowItem.id === 77) {
            baseFormFields = AssessmentConfig(workflowItem.fields);
        }
        else {
            throw new Error("MigrationCreateModal.getFormFields: Unsupported workflow!");
        }

        const { formFields, unsupportedCustomFieldWarning } = MigrationHelper.getFormFieldsConfig(baseFormFields, workflowItem, customFields, MIGRATION_MODE.SYSTEM);
        if (unsupportedCustomFieldWarning) {
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "BATCH_OPS.WARNING.UNSUPPORTED_CF" }), { variant: "warning", persist: true });
        }
        return formFields;
    }
    downloadTemplate = async (e) => {
        try {
            if (this.props.closeSnackbar) {
                this.props.closeSnackbar();
            }
            const formObj = this.formRef.current.instance().option("formData");
            if (formObj.workflowid) {
                let workflowItem = this.getWorkflowItem(formObj.workflowid);
                const customFields = await this.getCustomFields(formObj.companyid, formObj.workflowid);
                const formFields = await this.getFormFields(workflowItem, customFields);
                const workbook = MigrationHelper.getExcelTemplate(formFields, 'GBP', MIGRATION_MODE.SYSTEM);
                let documentName = "Import_" + workflowItem.title.replace(/\s/g, "") + '.xlsx';
                // if (formObj.workflowid === 103) {
                //     documentName = "Import_Quotation.xlsx";
                // }


                // https://github.com/exceljs/exceljs#writing-xlsx
                workbook.xlsx.writeBuffer()
                    .then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), documentName);
                    })
                    .catch(err => {
                        console.log(err);
                        this.props.enqueueSnackbar(err.toString(), { variant: 'error', });

                    });

            }
            else {
                throw new Error("Please select a workflow!");
            }
        } catch (err) {

            this.props.enqueueSnackbar(err.toString(), { variant: 'error', persist: true });
        }
    }
    validateFile = (file, progressCallback) => {
        return new Promise(async (resolve, reject) => {
            try {
                if (this.props.closeSnackbar) {
                    this.props.closeSnackbar();
                }
                this.popupRef.current.instance().option("disabled", true);
                const formObj = this.formRef.current.instance().option("formData");
                if (!formObj.workflowid) {
                    throw new Error("Please select a workflow!");
                }
                let workflowItem = this.getWorkflowItem(formObj.workflowid);
                const customFields = await this.getCustomFields(formObj.companyid, formObj.workflowid);
                const formFields = await this.getFormFields(workflowItem, customFields);

                const dataCommonProperties = {
                    workflowid: workflowItem.id,
                    notifyingparty: workflowItem.notifyingParty,
                    replyingparty: workflowItem.replyingParty,
                    quotingparty: workflowItem.quotingParty,
                    quotereplyingparty: workflowItem.quoteReplyingParty,
                    actioningparty: workflowItem.actioningParty,
                }
                const data = await MigrationHelper.processExcelFile(file, formFields, dataCommonProperties, customFields, null, MIGRATION_MODE.SYSTEM);
                if (!data || data.length === 0) {
                    throw new Error("No data found!")
                }
                this.state.processedData = data;
                this.state.processedFileName = file.name;
                this.popupRef.current.instance().option("toolbarItems[1].disabled", false);
                this.fileUploaderRef.current.instance().option("uploadFailedMessage", data.length + " rows validated");
                resolve();
            }
            catch (err) {

                this.state.processedData = null;
                this.state.processedFileName = null;
                this.fileUploaderRef.current.instance().clear();
                this.formRef.current.instance().option("validationError", "Error");
                this.formRef.current.instance().validate();
                this.popupRef.current.instance().option("toolbarItems[1].disabled", true);
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', persist: true });
                reject(err)
            }
            finally {
                this.popupRef.current.instance().option("disabled", false);
            }
        });
    }
    uploadFile = async () => {
        try {
            if (this.props.closeSnackbar) {
                this.props.closeSnackbar();
            }
            this.loadPanelRef.current.instance().option("visible", true)
            this.popupRef.current.instance().option("toolbarItems[0].disabled", true);
            this.popupRef.current.instance().option("toolbarItems[1].disabled", true);
            this.popupRef.current.instance().option("disabled", true);
            const formObj = this.formRef.current.instance().option("formData");
            const requestObj = {
                companyid: formObj.companyid,
                mastertemplateid: formObj.mastertemplateid,
                workflowid: formObj.workflowid,
                serializedrawdata: JSON.stringify(this.state.processedData),
                description: formObj.description,
                filename: this.state.processedFileName
            }
            const { data: batchResult } = await migrationCrud.importData(requestObj);
            this.props.onDialogResult(RESPONSES.SAVE);
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', persist: true });
        }
        finally {
            this.loadPanelRef.current.instance().option("visible", false)
            this.popupRef.current.instance().option("disabled", false);
            this.popupRef.current.instance().option("toolbarItems[0].disabled", false);
            this.popupRef.current.instance().option("toolbarItems[1].disabled", false);
        }


    }
    render() {
        return (
            <>
                <Popup
                    id='CreateMigrationPopup'
                    ref={this.popupRef}
                    visible={this.props.visible}
                    onHiding={this.onClose}
                    dragEnabled={true}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    title={"Upload Migration File"}
                    width={600}
                    height='auto'>
                    <LoadPanel
                        ref={this.loadPanelRef}
                        shadingColor="rgba(0,0,0,0.4)"
                        message='Uploading file content to server'
                        showIndicator={true}
                        shading={true}
                        showPane={true}
                        hideOnOutsideClick={false}
                    />
                    <Form
                        ref={this.formRef}
                        onFieldDataChanged={this.formFieldDataChanged}
                        labelMode='outside'
                        labelLocation='top'
                    >
                        <GroupItem>
                            <FormItem
                                label={{ text: this.props.intl.formatMessage({ id: 'PROJECT.FIELD.COMPANY' }) }}
                                dataField="companyid"
                                editorType="dxSelectBox"

                                editorOptions={{
                                    dataSource: this.getCompaniesListDataSource(),
                                    showClearButton: true,
                                    valueExpr: 'companyid',
                                    displayExpr: 'name',
                                    searchEnabled: true,
                                }}

                                isRequired
                            />
                            <FormItem
                                label={{ text: "Master Template" }}
                                dataField="mastertemplateid"
                                editorType="dxSelectBox"
                                editorOptions={{
                                    showClearButton: true,
                                    valueExpr: 'templateid',
                                    displayExpr: 'name',
                                    searchEnabled: true,
                                }}
                                isRequired
                            />
                            <FormItem
                                label={{ text: "Workflow" }}
                                dataField="workflowid"
                                editorType="dxSelectBox"
                                editorOptions={{
                                    showClearButton: true,
                                    valueExpr: 'value',
                                    displayExpr: 'display',
                                    searchEnabled: true,
                                    buttons: [{ name: 'clear' }, {
                                        name: 'download',
                                        location: 'after',
                                        options: {
                                            icon: 'download',
                                            hint: 'Download Template',
                                            onClick: this.downloadTemplate
                                        }
                                    },
                                    { name: 'dropDown' }]
                                }}
                                isRequired
                            />
                            <FormItem
                                label={{ text: this.props.intl.formatMessage({ id: 'ACTIONS.FIELD.DESCRIPTION' }) }}
                                dataField="description"
                                editorType="dxTextArea"
                                editorOptions={{ height: 100, maxLength: 250 }}
                                isRequired
                            />
                        </GroupItem>
                        <GroupItem >
                            <SimpleItem
                                label={{ visible: false }}
                                dataField="file"
                            >
                                <FileUploader
                                    ref={this.fileUploaderRef}
                                    width={"100%"}
                                    height={"100%"}
                                    style={{ border: '1px solid #ccc', borderRadius: '10px' }}
                                    multiple={false}
                                    showFileList={true}
                                    uploadedMessage='File validated, ready to upload'
                                    invalidFileExtensionMessage='Only .xlsx files are allowed'
                                    invalidMaxFileSizeMessage='File is too large'
                                    maxFileSize={4000000}
                                    allowedFileExtensions={fileExtensions}
                                    accept={".xlsx"}
                                    uploadMode="instantly"
                                    uploadFile={this.validateFile}
                                    uploadFailedMessage='Errors found while validating file data!'
                                />
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={{ text: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_CANCEL' }), onClick: this.onClose }}>
                    </ToolbarItem>
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={{
                            text: "Upload File",
                            icon: 'save',
                            onClick: this.uploadFile,
                        }}>
                    </ToolbarItem>
                </Popup >
            </>

        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractTemplate: store.contract.template,
});

export default connect(mapStateToProps)(withSnackbar(injectIntl(MigrationCreateModal)));